// Iframe protection utility
class IframeProtection {
    constructor() {
        this.init();
    }

    init() {
        // Remove existing problematic iframes
        this.removeProblematicIframes();
        
        // Set up mutation observer to catch new iframes
        this.setupMutationObserver();
        
        // Set up periodic cleanup
        this.setupPeriodicCleanup();
    }

    removeProblematicIframes() {
        const problematicIframes = document.querySelectorAll('iframe');
        
        problematicIframes.forEach(iframe => {
            const style = iframe.getAttribute('style') || '';
            
            // Check for suspicious iframe characteristics
            if (this.isSuspiciousIframe(iframe, style)) {
                console.warn('Removing suspicious iframe:', iframe);
                iframe.remove();
            }
        });
    }

    isSuspiciousIframe(iframe, style) {
        // Check for full-screen overlay characteristics
        const hasFixedPosition = style.includes('position: fixed') || style.includes('position:fixed');
        const hasFullDimensions = (style.includes('width: 100%') || style.includes('width:100%')) && 
                                 (style.includes('height: 100%') || style.includes('height:100%'));
        const hasHighZIndex = style.includes('z-index: 2147483647') || style.includes('z-index:2147483647');
        const hasTopLeftPosition = (style.includes('top: 0') || style.includes('top:0')) && 
                                  (style.includes('left: 0') || style.includes('left:0'));

        // Check if iframe has no src or suspicious src
        const src = iframe.getAttribute('src') || '';
        const hasNoSrc = !src || src === '' || src === 'about:blank';

        return hasFixedPosition && hasFullDimensions && hasHighZIndex && hasTopLeftPosition && hasNoSrc;
    }

    setupMutationObserver() {
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                mutation.addedNodes.forEach((node) => {
                    if (node.nodeType === Node.ELEMENT_NODE) {
                        if (node.tagName === 'IFRAME') {
                            const style = node.getAttribute('style') || '';
                            if (this.isSuspiciousIframe(node, style)) {
                                console.warn('Blocking suspicious iframe injection:', node);
                                node.remove();
                            }
                        }
                        
                        // Check for iframes in added subtrees
                        const iframes = node.querySelectorAll && node.querySelectorAll('iframe');
                        if (iframes) {
                            iframes.forEach(iframe => {
                                const style = iframe.getAttribute('style') || '';
                                if (this.isSuspiciousIframe(iframe, style)) {
                                    console.warn('Blocking suspicious iframe in subtree:', iframe);
                                    iframe.remove();
                                }
                            });
                        }
                    }
                });
            });
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    setupPeriodicCleanup() {
        // Run cleanup every 5 seconds
        setInterval(() => {
            this.removeProblematicIframes();
        }, 5000);
    }
}

// Initialize protection when DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
        new IframeProtection();
    });
} else {
    new IframeProtection();
}

export default IframeProtection;